import React, { Component } from "react";
import Dropdown from './dropdown';
import InputField from './inputField';
import {uberRequestReasonOptions, isValidPhoneNumber, errorMessages, 
    dashifyPhoneNumber, maxLength, USER_DETAIL_SESSION_KEY, USER_TIME_SESSION_KEY, isIdenticalPhNumber } from '../utils/constants';
import { postChatSurveyConfigApi } from '../apis/botApi';
import './style.scss';
import { osName, browserName, fullBrowserVersion, isMobile } from 'react-device-detect';
import SessionExpiredPopup from './SessionRefresh';
import PrivacyPopup from './PrivacyStatement';
import {playSilentNotifications} from '../utils/alert';
import { setSession, getItemFromSession } from '../utils/common';

export default class UberSurveyForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errors: {},
            isSubmitOnce: false,
            name: props.name,
            employeeId: props.employeeId || props.email,
            email: props.email,
            phone: '',
            queue: (props.queueList && props.queueList[0]) ? props.queueList[0] : {label: '', value: ''},
            reason: uberRequestReasonOptions[0],
            details: '',
            handlePrivacyChecked: false,
            openRefreshPopup: false,
            openPrivacyPopup: false
        };
    }

    componentDidMount(){
        this.props.resetPrechatResponse();
    }

    handleTextFieldChange = (e) => {
        let { isSubmitOnce, errors } = this.state;
        let errorObj = {...errors};
        let textName = e && e.target && e.target.name;
        let textValue = e.target.value;
        if(textName === "details"){
            if(textValue && textValue.length > maxLength.detailLength){
                errorObj.details = errorMessages.details;
            }else {
                delete errorObj.details;
          }
        } 
        // if(textName === "phone"){
        //     if(!isValidPhoneNumber(textValue) || isIdenticalPhNumber(textValue)){
        //        errorObj.phone = errorMessages.valid_ph;
        //     }else {
        //         delete errorObj.phone; 
        //    }
        //     textValue=dashifyPhoneNumber(textValue).trim();
        // }
        this.setState({
            [e.target.name]: textValue,
            errors: {...errorObj},
        }, () => {
            if (isSubmitOnce) {
                this.validateFields()
            }
        });
    }

    handlePrivacyCheck = (e) => {
        this.setState({ handlePrivacyChecked: e.target.checked });
    };

    handleRequestDropdown = (selectedOption) => {
        this.setState({
            reason: selectedOption,
        })
    }

    handleDepartmentDropdown = (selectedOption) => {
        this.setState({
            department: selectedOption,
        })
    }

    handleSupportDepartmentDropdown = (selectedOption) => {
        this.setState({
            supportDepartment: selectedOption,
        })
    }

    handleQueueDropdown = (selectedOption) => {
        this.setState({
            queue: selectedOption,
        })
    }

    validateFields = () => {
        let { name, employeeId, queue, phone, errors, reason } = this.state;
        let errorObj = {};
        let isError = false;
        let errorField = "";
        if (name.length == 0) {
            errorObj.name = errorMessages.name;
            isError = true;
            errorField = "name";
        }
        // if (phone.length == 0) {
        //     errorObj.phone = errorMessages.phone;
        //     isError = true;
        //     errorField = errorField ? errorField : "phone_no";
        // }else if(phone.length !== 12){
        //     errorObj.phone = errorMessages.valid_ph;
        //     isError = true;
        //     errorField = errorField ? errorField : "phone_no";
        // }else if(isIdenticalPhNumber(phone)) {
        //     errorObj.phone = errorMessages.valid_ph;
        //     isError = true;
        //     errorField = errorField ? errorField : "phone_no";
        // }
        if (queue && queue.value <= 0) {
            errorObj.queue = errorMessages.queue;
            isError = true;
            errorField = errorField ? errorField : "queue";
        }
        if (reason.length == 0) {
            errorObj.reason = errorMessages.reason;
            isError = true;
        }
        this.setState({
            errors: {...errors, ...errorObj},
            isSubmitOnce: true
        })
        if(Object.keys(errorObj).length > 0 || Object.keys(errors).length > 0)
          isError = true;
          let elem = document.getElementById(errorField);
          let position = document.getElementsByClassName('rcw-survey-form')[0];
          position.scrollTop = elem && elem.offsetTop && elem.offsetTop - 85;
         return isError;
    }

    onSubmit = () => {
        const relayState = getItemFromSession("relayStateOneLogin") || '';
        const submitObject = {
            settings: {
                props: {
                    name: this.state.name,
                    xid: this.state.employeeId,
                    email: this.state.email,
                    phone_number: this.state.phone,
                    dept: '',
                    support_dept: '',
                    queue: this.state.queue.value,
                    queue_name: this.state.queue.label,
                    bname: '',
                    btn: '',
                    request_reason: this.state.reason.value,
                    request_detail: this.state.details.trim(),
                },
            },
            meta:{
                browser: browserName,
                os: osName,
                version: fullBrowserVersion,
                device: isMobile ? "Mobile": "Web"
            }
        };
        if (this.validateFields()) {
            return;
        }
        this.props.showHideLoader(true);
        postChatSurveyConfigApi(this.props.botId, submitObject, relayState).then(res => {
            const response = res.data;
            this.props.showHideLoader(false);
            if (response.status == "ok") {
                this.props.chatSurveyFormSubmitHandler(response);
                setSession(USER_DETAIL_SESSION_KEY, JSON.stringify(response.result));
                setSession(USER_TIME_SESSION_KEY, new Date().getTime());
            }
        }).catch(err => {
            this.props.showHideLoader(false);
            console.log("Error Saving form details", err);
            this.setState({
                openRefreshPopup: true
            })
        });
        // play silent notification to enable further auto play sound
        playSilentNotifications();
    };

    closeRefreshPopup = () => {
        this.setState({
            openRefreshPopup: false
        })
    }
    onPrivacyClick=(e)=>{
        e.preventDefault();
        this.setState({
            openPrivacyPopup: true
        });
    }
    closePrivacyPopup = () => {
        this.setState({
            openPrivacyPopup: false
        });
    }
    render() {
        const { phone, name, employeeId, email, queue, details, reason, errors, handlePrivacyChecked, openRefreshPopup, openPrivacyPopup } = this.state;
        const {queueList=[]}=this.props;
        let disableBtn =  handlePrivacyChecked ? false : true;
        return (
            <>
                {openRefreshPopup && <SessionExpiredPopup open={openRefreshPopup} close={this.closeRefreshPopup}/>}
                {openPrivacyPopup && <PrivacyPopup open={openPrivacyPopup} close={this.closePrivacyPopup}/>}
                <div className="rcw-survey-form">
                    <div className="chat-survey-form">
                        <h4 className="label1">
                            What service can we help you with?
                       </h4>
                        <InputField
                            name="name"
                            label="Name"
                            id="name"
                            type="text"
                            value={name}
                            placeholder="Enter your name"
                            disabled={!!name}
                            onChange={(e) => this.handleTextFieldChange(e)}
                            errors={errors.name}
                        />
                        <InputField
                            name="employeeId"
                            label="Employee ID"
                            id="employee_id"
                            type="text"
                            value={employeeId}
                            placeholder="Employee ID"
                            disabled={!!employeeId}
                            onChange={(e) => this.handleTextFieldChange(e)}
                        />
                        {/* <InputField
                            name="phone"
                            label="Phone Number"
                            type="text"
                            id="phone_no"
                            value={phone}
                            placeholder="XXX-XXX-XXXX"
                            disabled={!!phone}
                            onChange={(e) => this.handleTextFieldChange(e)}
                            errors={errors.phone}
                        /> */}
                        <Dropdown label="LOB" id="queue" selectedValue={queue} dropdownOptions={queueList} errors={errors.queue} onDropdownChange={this.handleQueueDropdown} />
                        <Dropdown label="Type of Assistance" id="req_reason" selectedValue={reason} dropdownOptions={uberRequestReasonOptions} errors={errors.reason} onDropdownChange={this.handleRequestDropdown} />
                        <div className="m-t-10">
                            <label htmlFor="title" className="form-labels">
                                Bliss Link
                             </label>
                            <div className="req-detail">
                                <textarea
                                    name="details"
                                    value={details}
                                    placeholder="Please enter the Bliss Link"
                                    onChange={(e) => this.handleTextFieldChange(e)}
                                />
                            </div>
                        </div>
                        {errors && <div className="field-error">{errors.details}</div>}
                        <div className="m-t-25">
                          <label className="term-condition">
                            I agree to the <a onClick={this.onPrivacyClick}  target="_blank" className="pr-policy">Privacy Statement</a>
                            <input
                               type="checkbox"
                               checked={handlePrivacyChecked}
                               onChange={(e) => this.handlePrivacyCheck(e)}
                            />
                            <span className="checkmark"></span>
                            </label>
                        </div>
                        <div className="d-flex m-t-2">
                            <button className="start-chat-button"  onClick={this.onSubmit} disabled={disableBtn}>
                                <i aria-hidden="true" />
                               Start Chat
                           </button>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

